var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gumb-App-(MVP)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-event_owner_MVP-2_desktop",
    transform: "translate(-1160.000000, -183.000000)",
    fill: "#8298AB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1064.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-Event"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(19.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.4999857,76.6875246 C86.7099085,76.6875246 89.3124718,79.2910264 89.3124718,82.5000107 C89.3124718,85.7108719 86.7099085,88.3124969 83.4999857,88.3124969 C80.2900629,88.3124969 77.6874996,85.7108719 77.6874996,82.5000107 C77.6874996,79.2910264 80.2900629,76.6875246 83.4999857,76.6875246 Z M83.4999857,87.1874996 C86.0914483,87.1874996 88.1874745,85.0905578 88.1874745,82.5000107 C88.1874745,79.9094865 86.0896173,77.8125219 83.4999857,77.8125219 C80.9094844,77.8125219 78.8124969,79.9102876 78.8124969,82.5000107 C78.8124969,85.0914734 80.9093928,87.1874996 83.4999857,87.1874996 Z M83.4999857,79.2656434 C84.0436474,79.2656434 84.4843583,79.7063544 84.4843583,80.2500161 C84.4843583,80.7936778 84.0436474,81.2343887 83.4999857,81.2343887 C82.956324,81.2343887 82.515613,80.7936778 82.515613,80.2500161 C82.515613,79.7063544 82.956324,79.2656434 83.4999857,79.2656434 Z M84.8124826,85.2187542 C84.8124826,85.3740731 84.6865521,85.5000036 84.5312332,85.5000036 L82.4687382,85.5000036 C82.3134193,85.5000036 82.1874888,85.3740731 82.1874888,85.2187542 L82.1874888,84.6562556 C82.1874888,84.5009367 82.3134193,84.3750063 82.4687382,84.3750063 L82.7499875,84.3750063 L82.7499875,82.8750098 L82.4687382,82.8750098 C82.3134193,82.8750098 82.1874888,82.7490793 82.1874888,82.5937605 L82.1874888,82.0312618 C82.1874888,81.875943 82.3134193,81.7500125 82.4687382,81.7500125 L83.9687346,81.7500125 C84.1240534,81.7500125 84.2499839,81.875943 84.2499839,82.0312618 L84.2499839,84.3750063 L84.5312332,84.3750063 C84.6865521,84.3750063 84.8124826,84.5009367 84.8124826,84.6562556 L84.8124826,85.2187542 Z",
    id: "info"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.81970dd6.svg";
export { ForwardRef as ReactComponent };